import React from "react";
import { FeedStackSection } from "src/components/FeedContainer";
import { ProjectBox } from "src/components/Projects";

export const ContentSectionBelowLg = () => {
  return (
    <FeedStackSection
      renderContent={(row, index) => <ProjectBox key={index} row={row} />}
    />
  );
};
